import getDate from '../../../../apis/api'
export default {
  queryCodeinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_QUERYCODEINFO(params).then((res) => {
        resolve(res)
        state.codeinfo = {}
        state.codeisexsist = false
        state.optgoodsinfos = []
        state.optgoods = []
        if (res.data.status == '001') {
            // 礼品券卡，消费卡
              if (res.data.data.codeinfo != null) {
                state.codeinfo = res.data.data.codeinfo
                state.codeisexsist = true
                let yy = '';
                if (state.codeinfo.codetype == 0) {
                  state.optgoodsinfos = res.data.data.optgoodsinfos
                  if(state.codeinfo.defaultgoodscode&&state.codeinfo.defaultgoodscode!='0'){
                    if(state.optgoodsinfos.length>0){
                      yy = state.optgoodsinfos[0].optgoodscode + '#' + state.codeinfo.defaultgoodscode
                      state.optgoodsinfos[0].optgoodscode = yy
                    }
                  }
                  state.optgoods = res.data.data.optgoods
              }
              }
          }
        if (res.data.status == '007') {
          // 优惠券
          if (res.data.data.coupon != null) {
            state.coupon = res.data.data.coupon
            console.log(state.coupon.code)
          }
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 查询商品图片
  selGoodspicList ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_SELGOODSPICLIST(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          // 商品图片回去成功
          if (state.goodspiclist != null) {
            state.goodspiclist = res.data.data
          }
        } else {
          state.checkErrorMessage = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 查询指定品牌的预售配置信息
  selCardsysbaseinfoByBrand ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_SELCARDSTSBASEINFOBYBRAND(params).then((res) => {
        resolve(res)
        state.cardsysbaseinfo = {}
        if (res.data.status == '001') {
          // 品牌个性配置信息获取成功
          if (state.cardsysbaseinfo != null) {
            state.cardsysbaseinfo = res.data.data
          }
        } else {
          state.checkErrorMessage = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 申请送货、到店自提调用该接口进行初始化
  exchangeInit ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_EXCHANGEINIT(params).then((res) => {
      resolve(res)
      // 初始化把验证的券卡清空
      state.resultinfoCode = []
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 申请送货、到店自提券卡验证接口
  exchangeCheckCode ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_EXCHANGECHECKCODE(params).then((res) => {
      resolve(res)
      if (res.data.status == '001') {
        // 清空上一次验证的选择商品
        state.optgoodsinfos = []
        state.codeinfo = res.data.data.codeinfo
        state.resulttype = res.data.data.resulttype
        // 判断是否是默认商品 如果是赋值 resultinfo
        if (res.data.data.resulttype == '0') {
          res.data.data.resultinfo.hresiduenum = res.data.data.codeinfo.residuenum
          state.resultinfo = res.data.data.resultinfo
          // 循环遍历判断是否有当前验证的券卡
          var flag = false
          for (var i = 0; i < state.resultinfoCode.length; i++) {
            if (state.resultinfoCode[i].code == state.resultinfo.code) {
              flag = true
            }
          }
          if (flag == false) {
            // 讲当前的券卡信息是否可以更改商品信息溶于当前集合
            res.data.data.resultinfo.optgoodsuid = state.codeinfo.optgoodsuid
            // 默认商品时候选择商品的数量
            res.data.data.resultinfo.selgoods[0].kindcodenum = 1
            // 重新对象放入数组
            let list = res.data.data.resultinfo
            
            //  list.map(item => {
            //    let sortcodes = item.optgoodscode;
            //    item.optgoods.sort((a, b) => {
            //      let as = a.cansel == 1 ? sortcodes.indexOf(a.kindcode) : sortcodes.indexOf(a.kindcode) + length;
            //      let bs = b.cansel == 1 ? sortcodes.indexOf(b.kindcode) : sortcodes.indexOf(b.kindcode) + length;
            //      console.log(as, bs, 'ooo')
            //      return as - bs;
            //    })
            //  })
            console.log(333333333)
            state.resultinfoCode.push(list)
          }
        } else {


          console.log(2222222)
          // let sortcodes = res.data.data.codeinfo.optgoodscode;
          let list = res.data.data.optgoodsinfos
          list.map(item => {
            let sortcodes = item.optgoodscode;
            item.optgoods.sort((a,b) => {
                 let as =a.cansel ==1?sortcodes.indexOf(a.kindcode) :sortcodes.indexOf(a.kindcode) +sortcodes.length;
                 let bs =b.cansel ==1?sortcodes.indexOf(b.kindcode):sortcodes.indexOf(b.kindcode) + sortcodes.length;
                 console.log(as,bs,'ooo')
                 return as - bs;
            })
          })
          // 是可以选商品
          state.optgoodsinfos = list
        }
      } else {
        state.resulttype = 0
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 删除已验证券卡接口
  removeCheckedCard ({state, commit}, params) {
    return getDate.GET_REMOVECHECKEDCARD(params).then((res) => {
      if (res.data.status == '001') {
        state.deleteFlag = true
      } else {
        state.checkErrorMessage = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 获取已验证卡券列表
  selExchangeItems ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_SELEXCHANGEITEMS(params).then((res) => {
      resolve(res)
      state.resultinfoCode = []
      if (res.data.status == '001') {
        state.resultinfoCode = res.data.data.exchangeItems
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 兑换提交订单接口
  submitPresellOrder ({state, commit}, params) {
    return getDate.GET_SUBMITPRESELLORDER(params).then((res) => {
      state.message = res.data.message
      if (res.data.status == '001') {
        state.orderno = res.data.data.orderno
        state.resultinfoCode = []
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 获取省市的接口
  getAddrinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_ADDRINFO(params).then((res) => {
      resolve(res)
      if (res.data.status == '001') {
        state.threeaddress = res.data.data
      } else {
        state.checkErrorMessage = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 申请送货/到店自提选择商品提交接口
  subChooseGoods ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_SUBCHOOSEGOODS(params).then((res) => {
      resolve(res)
      state.goodList = []
      if (res.data.status == '001') {
        res.data.data.hresiduenum = res.data.data.residuenum + res.data.data.usenum
        res.data.data.optgoodsuid = 'optgoodsuid'
        state.resultinfo = res.data.data
        var goodFlag = false
        // 循环选择的专区商品的列表信息
        // 如果有重复的规格信息 则累加
        for (var i = 0; i < res.data.data.selgoods.length; i++) {
          goodFlag = false
          // 循环选择的商品信息 放入集合
          if (state.goodList.length > 0) {
            for (var j = 0; j < state.goodList.length; j++) {
              // 判断选择的商品规格信息是否已经有了 如果没有则 加入 有则追加数量
              if (state.goodList[j].kindcode == res.data.data.selgoods[i].kindcode) {
                goodFlag = true
                state.goodList[j].kindcodenum = state.goodList[j].kindcodenum + 1
              }
            }
          } else {
            goodFlag = true
            res.data.data.selgoods[i].kindcodenum = 1
            state.goodList.push(res.data.data.selgoods[i])
          }
          // 当等于true的时候表示集合里面已经有此规格信息 flase 直接添加
          if (goodFlag == false) {
            res.data.data.selgoods[i].kindcodenum = 1
            state.goodList.push(res.data.data.selgoods[i])
          }
        }
        res.data.data.selgoods = state.goodList
        // 循环遍历判断是否有如果有则删除重新添加
        var flag = false
        for (var k = 0; k < state.resultinfoCode.length; k++) {
          if (state.resultinfoCode[k].code == res.data.data.code) {
            state.resultinfoCode[k].selgoods = res.data.data.selgoods;
            state.resultinfoCode[k].usenum = res.data.data.usenum;
            flag = true
          }
        }
        if (flag == false) {
          // 重新对象放入数组
          state.resultinfoCode.push(res.data.data)
        }
        console.log(state.resultinfoCode)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 更改商品初始化接口
  updateChooseGoods ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_UPDATECHOOSEGOODS(params).then((res) => {
      resolve(res)
      if (res.data.status == '001') {
        state.codeinfo = res.data.data.codeinfo
        state.resulttype = res.data.data.resulttype
         let list = res.data.data.optgoodsinfos
         list.map(item => {
           let sortcodes = item.optgoodscode;
           item.optgoods.sort((a, b) => {
             let as = a.cansel == 1 ? sortcodes.indexOf(a.kindcode) : sortcodes.indexOf(a.kindcode) + sortcodes.length;
             let bs = b.cansel == 1 ? sortcodes.indexOf(b.kindcode) : sortcodes.indexOf(b.kindcode) + sortcodes.length;
             console.log(as, bs, 'ooo')
             return as - bs;
           })
         })
         if(state.codeinfo.defaultgoodscode&&state.codeinfo.defaultgoodscode!=null&&state.codeinfo.defaultgoodscode!='0'){
            let min = list[0].listnum
           list[0].listnum = min+1
           state.optgoodsinfos = list
       }else{
         state.optgoodsinfos = list
       }
        let pickUpItem = res.data.data.pickUpItem
        if(pickUpItem.optItems.length>0) {
          state.optItems = pickUpItem.optItems
        } else if(pickUpItem.defaultgoodscode&&pickUpItem.defaultgoodscode!='0') {
          let list = [{
            selGoodscodes: [pickUpItem.defaultgoodscode],
            sort: 1
          }]
          state.optItems = list;
        }
        // state.optItems = res.data.data.exchangeItem.optItems
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 获取登录人的收货地址列表信息
  getAddrList ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_ADDRLIST(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          state.addresslist = res.data.data
        } else {
          state.message = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 获取全国门店
  getStoreList ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_STORELIST(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          state.storeList = res.data.data
        } else {
          state.message = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 获取门店详情
  getStoreDetail ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_GETSTOREDETAIL(params).then((res) => {
        resolve(res)
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
   // 订单详情基础数据接口，包含订单基本信息、收货人信息，如果是到店自提订单，还包含到店自提门店信息（不限制登录用户）
   getOrderinfoBaseDetByOrderno ({state, commit}, params) {
    return getDate.GET_ORDERINFOBASEDETBYORDERNO(params).then((res) => {
      if (res.data.status == '001') {
        state.orderinfo = res.data.data.orderinfo
        state.receiverinfo = res.data.data.receiverinfo
        state.flowinfo = res.data.data.flowinfo
        if (res.data.data.orderinfo.interactivitystate == 1) {
          state.actshow = true
        }
      } else {
        state.message = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 获取订单基础信息
  getOrderinfo ({state, commit}, params) {
    return getDate.GET_ORDERINFOBASEDET(params).then((res) => {
      if (res.data.status == '001') {
        state.orderinfo = res.data.data.orderinfo
        state.receiverinfo = res.data.data.receiverinfo
        state.flowinfo = res.data.data.flowinfo
        if (res.data.data.orderinfo.interactivitystate == 1) {
          state.actshow = true
        }
      } else {
        state.message = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 根据订单号查询关联券卡的剩余使用次数
  selResiduenumByOrderno ({state, commit}, params) {
    return getDate.GET_SELRESIDUENUMBYORDERNO(params).then((res) => {
      if (res.data.status == '001') {
        state.resnumlist = res.data.data
      } else {
        state.message = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  // 企业的基订单和发货配置信息
  getPubordprintinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
    return getDate.GET_PUBORDPRINTINFO(params).then((res) => {
      resolve(res)
      if (res.data.status == '001') {
        state.pubordprintinfo = res.data.data
      } else {
        state.message = res.data.message
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
    })
  },
  // 更改已验证券卡的消耗次数
  changeUsenum ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_CHANGEUSENUM(params).then((res) => {
        resolve(res)
        state.message = res.data.message
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 期望发货日期获取
  getExchangeOrderRecvdateSetParm ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_EXCHANGEORDERRECVDATESETPARM(params).then((res) => {
        resolve(res)
        state.startdate = ''
        if (res.data.status == '001' && res.data.data) {
         state.startdate = res.data.data.startdate
         state.enddate = res.data.data.enddate
         state.unsendtimestr = res.data.data.unsendtimestr
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 获取付款信息
  getCarddispayinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_CARDDISPAYINFO(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          state.addresslist = res.data.data
        } else {
          state.message = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 获取微信付款码Url
  getWxPayCarddispayinfoUrl ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_WXPAYCARDDISPAYINFOURL(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          state.addresslist = res.data.data
        } else {
          state.message = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
    // 获取二维码url
    getWxPayUrl ({
      state,
      commit
    }, params) {
      return new Promise(function (resolve, reject) {
        return getDate.GETWXPAYURL(params).then((res) => {
          resolve(res)
        }).catch((thrown) => {
          reject(thrown)
        })
      })
    },
   // 获取订单付款信息，包括付款信息初始化和校验付款结果
   getOrderpayinfo ({
    state,
    commit
  }, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_ORDERPAYINFO(params).then((res) => {
        resolve(res)
      }).catch((thrown) => {
        reject(thrown)
      })
    })
  },
  // 分销付款订单提交
  addCarddispayinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_ADDCARDDISPAYINFO(params).then((res) => {
        resolve(res)
        if (res.data.status == '001') {
          state.addresslist = res.data.data
        } else {
          state.message = res.data.message
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    })
  },
  // 删除状态管理器储存的订单号
  deleteOrderno({state}) {
    state.orderno = "";
  }
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/cardProject/actions/actions.js